// extracted by mini-css-extract-plugin
export default {"cropper":"style_cropper__wPPRv"};